export interface Supplier {
  id: string;
  name: string;
  contact_name?: string | null;
  email?: string | null;
  phone?: string | null;
  street_address?: string | null;
  suburb?: string | null;
  city?: string | null;
  province_state?: string | null;
  postal_code?: string | null;
  website?: string | null;
  default_minimum_order?: number | null;
  category_id?: string | null;
  trade_ids?: string[] | null;
  metadata?: any | null;
  created_at: string;
  updated_at?: string | null;
  created_by?: string | null;
}

export interface SupplierSortOption {
  value: string;
  label: string;
}

export const SUPPLIER_SORT_OPTIONS: SupplierSortOption[] = [
  { value: 'name', label: 'Name' },
  { value: 'contact_name', label: 'Contact Name' },
  { value: 'created_at', label: 'Date Added' },
  { value: 'updated_at', label: 'Last Modified' },
  { value: 'city', label: 'City' },
  { value: 'email', label: 'Email' },
];